var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kt-panel',{staticClass:"z-depth-0 bg-transparent m-0"},[_c('kt-panel-header',{staticClass:"border-0 p-0"},[_c('kt-panel-header-actions',{style:(_vm.headerAction)},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }